import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Form } from '@kuzmycz/react-form-ula';
import { Button, Modal, Tab } from '../../../../Components/uielements';
import BioPlusTextField from '../../../../Components/form-fields/BioPlusTextField';
// import DropDown from '../../../../Components/uielements/dropDown';
import {
  ModalButtonWrapper,
  ModalGap,
  OutlineButton,
} from '../../../../services/settings/appStyle/global.style';
import UserService from '../../../../services/bioplus-services/user';
import { UserSchema } from '../validators/editUserValidator';
import { IntlMessages } from '../../../../helper/langHelper';
import { ModalWrapper, TabContainer } from '../user.style';
// import PermissionForm from './permissonForm';
import PermissionFormV2 from './permissionFormV2';
// import PermissionFormV2 from './permissionFormV2';
// import PremisesForm from './premisesForm';

const getEditUserUrlBasedOnRole = async (userRole, editData) => {
  if (userRole === 'owner') {
    return await UserService.update(editData);
  } else if (userRole === 'partner') {
    UserService.updateByPartner(editData.partnerId, editData);
  }
};

const UserEditAndPermissionModal = ({ onClose, data, userRole, options = [], invalidateQuery }) => {
  const [selectedRole, setSelectedRole] = useState();
  const [activeTab, setActiveTab] = useState('edit');
  const queryClient = useQueryClient();

  const mutation = useMutation((user) => getEditUserUrlBasedOnRole(userRole, user), {
    onSuccess: async () => {
      await queryClient.invalidateQueries(invalidateQuery);
      onClose();
    },
    onError: (error) => {
      alert(`Error: ${error?.response?.data?.message}`);
      onClose();
    },
  });

  const handleSubmit = (values) => {
    const value = {
      ...values,
      ...(selectedRole && { role: selectedRole }),
    };
    mutation.mutate(value);
  };

  const validator = (values) => {
    return UserSchema.validate(values);
  };

  // const handleSelectedValue = (value) => {
  //   setSelectedRole(value.value);
  // };

  const tabArray = [
    {
      buttonText: 'Edit',
      value: 'edit',
      textId: '1',
    },
    {
      buttonText: 'Permission',
      value: 'permission',
      textId: '2',
    },
    // {
    //   buttonText: 'Premises',
    //   value: 'premises',
    //   textId: '3',
    // },
  ];

  const handleTabClick = (clickedTab) => {
    if (clickedTab) {
      setActiveTab(clickedTab);
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'edit':
        return (
          <Form initialValues={data} validator={validator} onSubmit={handleSubmit}>
            <ModalWrapper>
              <ModalGap>
                <BioPlusTextField
                  name="userName"
                  label={<IntlMessages id="input.label.name" defaultValue="Name" />}
                  fullWidth
                />
                <BioPlusTextField
                  name="email"
                  label={<IntlMessages id="input.label.email" defaultValue="Email" />}
                  fullWidth
                  disabled
                />
                <BioPlusTextField
                  name="phone"
                  label={<IntlMessages id="input.label.phone.no" defaultValue="Phone No" />}
                  fullWidth
                  disabled
                />
                <BioPlusTextField
                  name="companyName"
                  label={<IntlMessages id="input.label.name" defaultValue="Name" />}
                  fullWidth
                />
                {/* <DropDown
                  options={options}
                  selectedOption={handleSelectedValue}
                  name="role"
                  defaultValue={data.role}
                  label={<IntlMessages id="input.label.role" defaultValue="Role" />}
                /> */}
                <BioPlusTextField
                  name="role"
                  label={<IntlMessages id="input.label.role" defaultValue="Role" />}
                  fullWidth
                  disabled
                />
              </ModalGap>
              <ModalButtonWrapper>
                <OutlineButton onClick={onClose}>
                  <IntlMessages id="modal.button.cancel" defaultValue="Cancel" />
                </OutlineButton>
                <Button varient="normal" type="submit">
                  <IntlMessages id="modal.button.submit" defaultValue="Submit" />
                </Button>
              </ModalButtonWrapper>
            </ModalWrapper>
          </Form>
        );
      case 'permission':
        return (
          <>
            <PermissionFormV2 onClose={onClose} userData={data} invalidateQuery={invalidateQuery} />
          </>
        );
      // case 'premises':
      //   return (
      //     <>
      //       <PremisesForm onClose={onClose} userData={data} />
      //     </>
      //   );
      default:
        return null;
    }
  };

  return (
    <>
      <Modal
        isOpen={true}
        onClose={onClose}
        title={<IntlMessages id="modal.title.edit" defaultValue="Edit" />}
        isHeader={data?.role === 'OWNER' ? true : data?.role === 'CENTRAL MANAGER' ? true : false}
      >
        {data?.role !== 'OWNER' && data?.role !== 'CENTRAL MANAGER' && (
          <TabContainer>
            <Tab buttonArray={tabArray} onButtonClick={handleTabClick} activeTab={activeTab} />
          </TabContainer>
        )}
        {renderTabContent()}
      </Modal>
    </>
  );
};

export default UserEditAndPermissionModal;
